import React from 'react'
import LocalAsyncStore from '../../local-async-store'
import RecordMessages from '../record-messages'

export const ExpiryMessageWrapper = ({device_expiry}) => {
  let { loading, data } = device_expiry

  if (loading) return null
  if (!data.device_expiring && !data.key_expired) return null

  let message = 'B2B device expired. Please contact your Provider Administrator to refresh the device.'
  if(data.device_expiring && data.device_expires_at) {
    message = `B2B device will expire on ${data.device_expires_at}. Please contact your Provider Administrator to refresh the device, it's okay to refresh early.`
  }
  if(data.key_expired && data.key_expires_at) {
    message = 'An error has occurred with your B2B Device. CCS will not work until this is fixed. Please get in contact with Xplor Support to rectify the issue.'
  }

  return (
    <RecordMessages 
      messages={[
        {message: message},
      ]}
    />
  )
}

const apiEndPoint = ({service_id}) =>
  `/api/services/${service_id}/device-expiry`

export default LocalAsyncStore('device_expiry', ExpiryMessageWrapper, apiEndPoint)



// WEBPACK FOOTER //
// ./src/ui/expiry-message/index.jsx